/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProvinceModel } from '../../models/province-model';

export interface GetApiProvinceV1Id$Json$Params {

/**
 * The unique identifier of the province.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiProvinceV1Id$Json(http: HttpClient, rootUrl: string, params: GetApiProvinceV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
  const rb = new RequestBuilder(rootUrl, getApiProvinceV1Id$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProvinceModel>;
    })
  );
}

getApiProvinceV1Id$Json.PATH = '/private/v1/provinces/{id}';
